import * as signalR from "@microsoft/signalr";
import { AuthClient } from "./ApiClientBase";
import * as api from "./ApiClient";
export class ALMNotificationsHandler {
    private connection: signalR.HubConnection | null;
    private context: any;
    public deploymentId: string | null = null;
    constructor(context: any) {
        this.context = context;
        this.connection = null;
    }
    async start() {
        if (this.connection != null) return;
        var auth_client = AuthClient.getInstance();
        await auth_client.ensureToken();

        var client = new api.SignalRClient(auth_client);
        var data = await client.getSignalRConfig();
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(data.url!, { accessTokenFactory: () => data.token! })
            .build();

        this.connection.on("ALMNotification", (messageReceived, data: string) => {
            console.log("ALM Notification received", messageReceived, data);
            this.HandleNotification(JSON.parse(data));
        });
        this.connection.start();

        this.connection.onclose(() => {
            if (this.connection != null) this.connection.start();
        });
    }

    stop() {
        if (this.connection != null) {
            var con = this.connection;
            this.connection = null;
            con.stop();
        }
    }

    public async HandleNotification(notification: api.ToastNotification) {
        await this.context.dispatch("alm/getChangesets", null, { root: true });
    }
}
